const pagesSettingsSettingsEn = {
  navigation: {
    authentication: "Authentication",
  },
  authentication: {
    title: "Authentication",
    mfa: {
      title: "MFA",
      description:
        "Multi-Factor Authentication (MFA) adds an extra layer of security by asking users to confirm their identity in more than one way.",
      userType: {
        operator: "Staff",
        individual: "Member",
      },
      mfaMethod: {
        email: "Email",
      },
      card: {
        title: "Email",
        description:
          "Choose account types to require MFA when sign in and password reset.",
        requiredAccountTypes: "Required account types:",
        edit: "Edit",
      },
      editDialog: {
        title: "Editing MFA",
        description:
          "Choose account types to require MFA when sign in and password reset.",
        cancelButton: "Cancel",
        saveButton: "Save",
      },
      deleteDialog: {
        title: "Are you sure to remove MFA requirement?",
        description:
          "Removing the MFA requirement will significantly impact account security. Please confirm if you want to continue to save changes.",
        discardChangesButton: "Discard changes",
        continueButton: "Continue",
      },
    },
  },
};

export default pagesSettingsSettingsEn;
